export default __webpack_public_path__ + "static/media/active-level-2.ad2c71c2.svg";